export const BROCHURE_PDF_URL =
  process.env.REACT_APP_BROCHURE_PDF_URL ||
  "https://cdn.fo.newvgroup.com/brochures/nvfo-global-immigration-programs-overview-q3-2026.pdf";
